// Sensible default masker: keep a little context on both ends.
export const maskValue = (
  value: string,
  visibleStart = 2,
  visibleEnd = 2,
  maskChar = '*'
): string => {
  if (!value) return value;
  const len = value.length;
  if (len <= visibleStart + visibleEnd) return maskChar.repeat(len);
  return (
    value.slice(0, visibleStart) +
    maskChar.repeat(len - visibleStart - visibleEnd) +
    value.slice(len - visibleEnd)
  );
};

/**
 * Replaces secrets in strings
 */
export const scrambleSecrets = (input: string): string => {
  let s = input;

  s = s.replaceAll(
    /(Authorization:\s*ApiKey\s+)(\S+)/gi,
    (_m, pre: string, token: string) => pre + maskValue(token)
  );

  s = s.replaceAll(
    /(Authorization\s*=\s*"ApiKey\s+)([^"]+)/gi,
    (_m, pre: string, token: string) => pre + maskValue(token)
  );

  s = s.replaceAll(
    /(Authorization:\s*Bearer\s+)(\S+)/gi,
    (_m, pre: string, token: string) => pre + maskValue(token)
  );

  s = s.replaceAll(
    /([?&]token=)([^&\s"'`]+)/gi,
    (_m, pre: string, token: string) => pre + maskValue(token)
  );

  s = s.replaceAll(
    /("NG_API_AUTHTOKEN"\s*:\s*")(.*?)(")/g,
    (_m, pre: string, token: string, post: string) => pre + maskValue(token) + post
  );

  // Optional: Bearer support
  s = s.replaceAll(
    /(Authorization:\s*Bearer\s+)([^\s\r\n]+)/gi,
    (_m, pre: string, token: string) => pre + maskValue(token)
  );

  return s;
};
